let registerSound: HTMLAudioElement;
let ringSound: HTMLAudioElement;
let busySound: HTMLAudioElement;
let finishSound: HTMLAudioElement;
let messageSound: HTMLAudioElement;
let popSound: HTMLAudioElement;
let initialized: boolean = false;

// const registerUrl = './sounds/REGISTER.mp3';
// const messageUrl = './sounds/MESSAGE.mp3';
// const ringUrl = './sounds/CALL_OUT.mp3';
// const busyUrl = './sounds/BUSY.mp3';
// const finishUrl = './sounds/HANGUP.mp3';
// const popUrl = './sounds/POP.mp3';

import registerUrl from '../sounds/REGISTER.mp3'
import messageUrl from '../sounds/MESSAGE.mp3'
import ringUrl from '../sounds/CALL_OUT.mp3'
import busyUrl from '../sounds/BUSY.mp3'
import finishUrl from '../sounds/HANGUP.mp3'
import popUrl from '../sounds/POP.mp3'


export const initSounds = function (): void {
    if (!initialized) {
        registerSound = initSound(registerUrl, false, "auto");
        messageSound = initSound(messageUrl, false, "auto");
        ringSound = initSound(ringUrl, true, "none");
        busySound = initSound(busyUrl, false, "none");
        finishSound = initSound(finishUrl, false, "none");
        popSound = initSound(popUrl, false, "none");
        initialized = true;
    }
};

const initSound = function (src: string, loop: boolean, preload: "auto" | "none" | "metadata"): HTMLAudioElement {
    if (typeof loop == 'undefined') {
        loop = false;
    }
    const audioTag = document.createElement("audio");
    audioTag.autoplay = false;
    audioTag.preload = preload;
    if (loop) {
        audioTag.loop = true;
    }
    //add src tag to audio tag
    audioTag.src = src;
    document.body.appendChild(audioTag);
    return audioTag;
};

export default class SoundControl {
    private static _instance: SoundControl;

    private constructor() {
        if (SoundControl._instance) {
            throw new Error("Error: Instantiation failed: Use SoundControl.getInstance() instead of new.");
        }
        SoundControl._instance = this;
    }

    public static getInstance(): SoundControl {
        
        if (!SoundControl._instance) {
            SoundControl._instance = new SoundControl();
        }
        return SoundControl._instance;
    }

    //plays audio
    public playSound(soundName: string): void {
        try {
            let sound: HTMLAudioElement | undefined;
            switch (soundName) {
                case "RING":
                    sound = ringSound;
                    break;
                case "BUSY":
                    sound = busySound;
                    break;
                case "REGISTER":
                    sound = registerSound;
                    break;
                case "FINISH":
                    sound = finishSound;
                    break;
                case "MESSAGE":
                    sound = messageSound;
                    break;
                case "POP":
                    sound = popSound;
                    break;
                default:
                    console.error("Do not know what to play on " + soundName);
                    return;
            }
          
            if (sound) {
                sound.load();
                sound.play();
            }
        }
        catch (err) {
            console.info("This browser may not support sound.play() method: " + err);
        }
    }

    //stops audio
    public stopSound(soundName: string): void {
        try {
            switch (soundName) {
                case "RING":
                    if (ringSound && !ringSound.paused) {
                        ringSound.pause();
                        ringSound.currentTime = 0;
                    }
                    break;
                default:
                    console.error("Do not know what to stop on " + soundName);

            }
        }
        catch (err) {
            console.info("This browser may not support sound.pause() method or sound.currentTime property: " + err);
        }
    }
}
